export const mainAvatar = 'https://image.flaticon.com/icons/svg/667/667378.svg';